import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { SuperadminPageBlocker } from 'src/components/pages/superadmin/SuperadminPageBlocker';
import { LazyLoader } from './LazyLoader';

const ReviewsPage = LazyLoader(lazy(() => import('src/components/pages/superadmin/reviews/ReviewsPage')));
const ReportedReviewsPage = LazyLoader(
  lazy(() => import('src/components/pages/superadmin/reviews/ReportedReviewsPage'))
);
const MymesPage = LazyLoader(lazy(() => import('src/components/pages/superadmin/mymes/MymesPage')));
const ReportedMymesPage = LazyLoader(lazy(() => import('src/components/pages/superadmin/mymes/ReportedMymesPage')));
const AccountsPage = LazyLoader(lazy(() => import('src/components/pages/superadmin/accounts/AccountsPage')));
const ReviewReportListPage = LazyLoader(
  lazy(() => import('src/components/pages/superadmin/reviews/ReviewReportListPage'))
);
const MymeReportListPage = LazyLoader(lazy(() => import('src/components/pages/superadmin/mymes/MymeReportListPage')));

export const superAdminPageRoutes = {
  path: 'superadmin',
  element: <SuperadminPageBlocker />,
  children: [
    {
      path: '/app/superadmin',
      element: <Navigate to='/app/superadmin/mymes' />
    },
    {
      path: 'reviews',
      element: (
        <ReviewsPage
          type='auth-default'
          title='pages.superadmin.reviews.title_head'
          header={{ text: 'pages.superadmin.reviews.title_head' }}
        />
      )
    },
    {
      path: 'reported-reviews',
      element: (
        <ReportedReviewsPage
          type='auth-default'
          title='pages.superadmin.reviews.reported.title_head'
          header={{ text: 'pages.superadmin.reviews.reported.title_head' }}
        />
      )
    },
    {
      path: 'mymes',
      element: (
        <MymesPage
          type='auth-default'
          title='pages.superadmin.mymes.title_head'
          header={{ text: 'pages.superadmin.mymes.title_head' }}
        />
      )
    },
    {
      path: 'reported-mymes',
      element: (
        <ReportedMymesPage
          type='auth-default'
          title='pages.superadmin.mymes.reported.title_head'
          header={{ text: 'pages.superadmin.mymes.reported.title_head' }}
        />
      )
    },
    {
      path: 'accounts',
      element: (
        <AccountsPage
          type='auth-default'
          title='pages.superadmin.accounts.title_head'
          header={{ text: 'pages.superadmin.accounts.title_head' }}
        />
      )
    },
    {
      path: 'reported-reviews/:reviewId/report-list',
      element: (
        <ReviewReportListPage
          type='auth-default'
          title='pages.superadmin.report_list.title_head'
          header={{ text: 'pages.superadmin.report_list.title_head' }}
        />
      )
    },
    {
      path: 'reported-mymes/:mymeId/report-list',
      element: (
        <MymeReportListPage
          type='auth-default'
          title='pages.superadmin.report_list.title_head'
          header={{ text: 'pages.superadmin.report_list.title_head' }}
        />
      )
    }
  ]
};

export type SuperadminPageTitle =
  | 'pages.superadmin.reviews.title_head'
  | 'pages.superadmin.reviews.reported.title_head'
  | 'pages.superadmin.mymes.title_head'
  | 'pages.superadmin.mymes.reported.title_head'
  | 'pages.superadmin.accounts.title_head'
  | 'pages.superadmin.report_list.title_head';
